<template>
  <div :style="{ width: '100%', height }" ref="chartEl"></div>
  
</template>

<script>
export default {
  name: 'EChartsBox',
  props: {
    option: { type: Object, required: true },
    height: { type: String, default: '260px' },
    theme: { type: [String, Object], default: null },
    autoresize: { type: Boolean, default: true }
  },
  data() {
    return {
      chart: null,
      resizeHandler: null
    }
  },
  watch: {
    option: {
      deep: true,
      handler(val) {
        if (this.chart && val) {
          this.chart.setOption(val, true)
        }
      }
    }
  },
  mounted() {
    this.ensureEcharts().then(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (this.autoresize && this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler)
    }
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    ensureEcharts() {
      if (window.echarts) return Promise.resolve()
      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = 'https://cdn.jsdelivr.net/npm/echarts@5/dist/echarts.min.js'
        script.async = true
        script.onload = () => resolve()
        script.onerror = () => reject(new Error('Failed to load ECharts'))
        document.head.appendChild(script)
      })
    },
    initChart() {
      if (!this.$refs.chartEl) return
      const echarts = window.echarts
      this.chart = echarts.init(this.$refs.chartEl, this.theme || undefined)
      this.chart.setOption(this.option)
      if (this.autoresize) {
        this.resizeHandler = () => {
          if (this.chart) this.chart.resize()
        }
        window.addEventListener('resize', this.resizeHandler)
      }
    }
  }
}
</script>

<style scoped>
</style>

